var exports = {
  "x": "x620889e6--c0e62b--button",
};

module.exports = exports;
